import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getFeatures } from '../requests';

export const useGetFeatures = () =>
  useQuery({
    queryKey: [API_QUERY_KEYS.features],
    queryFn: getFeatures,
    select: response => response.data,
  });
